<template>
  <div>
    <el-form ref="form" size="mini" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_file') || '选择文件'"
            prop="fileCode"
          >
            <!-- <el-button type="primary" @click="upload()">
              {{ $l('INDEX.btn_select_file') || '选择文件' }}
            </el-button> -->

            <el-upload
              ref="upload"
              action="#"
              :limit="1"
              :file-list="file ? [file] : []"
              :auto-upload="false"
              :on-change="onFileChange"
              :on-remove="onFileRemove"
              :on-exceed="onFileExceed"
            >
              <el-button size="mini" type="primary">
                {{ $l('INDEX.btn_select_file') || '选择文件' }}
              </el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_docType') || '文档类型'"
            prop="docType"
          >
            <dict-select
              v-model="formData.docType"
              :placeholder="
                $l('INDEX.placeholder_select_docType') || '请选择文档类型'
              "
              url="/master/common/dict/biz"
              :body="{ dictType: 'DocType' }"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_tech_remark') || '文档说明'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              :placeholder="
                $l('INDEX.placeholder_tech_input_remark') || '请输入文档说明'
              "
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { listAmzSkuCode: { type: Array, default: () => [] } },
  data() {
    return {
      file: null,
      formData: { fileCode: '', fileName: '', docType: '', remark: '' },
      backDialogVisible: false,
      rules: {
        docType: [
          {
            required: true,
            message: this.$l('INDEX.tips_tech_docType') || '请选择文档类型',
            trigger: 'blur',
          },
        ],
        fileCode: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.file || value) {
                callback()
              } else {
                callback(
                  new Error(this.$l('INDEX.tips_tech_file') || '请选择文件')
                )
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {},
  methods: {
    ...mapActions('admin/upload', ['push']),
    onFileChange(file) {
      this.file = file
    },
    onFileRemove() {
      this.file = null
    },
    onFileExceed() {
      this.$message.warning(
        this.$l('INDEX.tips_tech_file_limit') || '只能上传一个文件'
      )
    },
    async uploadFile() {
      if (!this.file) return

      const { fileCode, fileName } = this.formData
      if (fileCode) return { fileCode, fileName }

      return new Promise((resolve) => {
        this.push({
          file: this.file.raw,
          added: ({ md5, suffix }) => {
            resolve({
              fileCode: [md5, suffix].filter(Boolean).join('.'),
              fileName: this.file.name,
            })
          },
          fail: () => {
            this.$message.error(
              this.$l('INDEX.tips_tech_upload_fail') || '文件上传失败'
            )
            resolve()
          },
        })
      })
    },
    async save() {
      if (!(await validate.formValidate([this.$refs.form]))) return

      this.loadingOpen()
      const result = await this.uploadFile()
      if (!result) return this.loadingClose()

      const { fileCode, fileName } = result
      this.formData.fileCode = fileCode
      this.formData.fileName = fileName

      const res = await this.$api
        .ecomAmzSkuDocUploadApi({
          ...this.formData,
          docGroup: 'SKU',
          listAmzSkuCode: this.listAmzSkuCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
      this.$emit('success')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
